import FinesApi from '../api/FinesApi';
import FinesConstants from '../constants/FinesConstants';

export function fetchTotalFines() {
  return {
    types: [
      FinesConstants.FETCH_FINES_REQUEST,
      FinesConstants.FETCH_FINES_SUCCESS,
      FinesConstants.FETCH_FINES_FAILURE
    ],
    middlewareData: {
      accountRequired: __CLIENT__
    },
    apiRequest: (state, apiClient) =>
      FinesApi.getFines(apiClient, '')
  };
}

export function fetchFines(query) {
  return {
    types: [
      FinesConstants.FETCH_FINES_REQUEST,
      FinesConstants.FETCH_FINES_SUCCESS,
      FinesConstants.FETCH_FINES_FAILURE
    ],
    middlewareData: {
      accountRequired: __CLIENT__
    },
    apiRequest: (state, apiClient) =>
      FinesApi.getFines(apiClient, query)
  };
}

export function updatePage(query) {
  return {
    types: [
      FinesConstants.UPDATE_PAGE_REQUEST,
      FinesConstants.UPDATE_PAGE_SUCCESS,
      FinesConstants.UPDATE_PAGE_FAILURE
    ],
    middlewareData: {
      accountRequired: __CLIENT__
    },
    apiRequest: (state, apiClient) =>
      FinesApi.getFines(apiClient, query)
  };
}

export function fetchFinesPaymentForm(query) {
  return {
    messagingId: 'finesNotice',
    types: [
      FinesConstants.FETCH_FINES_PAYMENT_FORM_REQUEST,
      FinesConstants.FETCH_FINES_PAYMENT_FORM_SUCCESS,
      FinesConstants.FETCH_FINES_PAYMENT_FORM_FAILURE
    ],
    middlewareData: {
      accountRequired: __CLIENT__
    },
    apiRequest: (state, apiClient) =>
      FinesApi.getFinesPaymentForm(apiClient, query)
  };
}

export default {
  fetchFines,
  fetchTotalFines
};



// WEBPACK FOOTER //
// ./app/actions/FinesActions.js